 
export const indicatorTaskDeleted = (chartData = {}) => {
   const days = Array.isArray(chartData.days) && chartData.days.length
    ? chartData.days
    : [];

   const safeArr = (arr) =>
    Array.isArray(arr) ? arr.map((n) => (Number.isFinite(+n) ? +n : 0)) : [];

  const deletedByDay = safeArr(chartData.deleted_by_day);

   const categoriesDeleted = chartData.categories_deleted || {
    A: 0,
    B: 0,
    C: 0,
    D: 0
  };

  const totalDeleted =
    Number.isFinite(+chartData.total_deleted) && +chartData.total_deleted >= 0
      ? +chartData.total_deleted
      : deletedByDay.reduce((acc, n) => acc + n, 0);

  return {
    chart: {
      type: "line",
      backgroundColor: "transparent",
      spacingTop: 20
    },

    title: { text: "" },

    xAxis: {
      title: { text: "Día del mes" },
      categories: days,
      crosshair: true
    },

    yAxis: {
      min: 0,
      title: { text: "Cantidad de objetivos Eliminados" },
      allowDecimals: false
    },

    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom"
    },

    tooltip: {
      useHTML: true,
      shared: false,
      formatter: function () {
        return `
          <div style="min-width:200px; padding:6px 8px;">
            <div style="font-weight:700; color:#6a1b9a; margin-bottom:4px;">
              Objetivos Eliminadas
            </div>

            <div style="display:flex; justify-content:space-between; margin-bottom:6px;">
              <span style="font-weight:700;">TOTAL</span>
              <span style="font-weight:700;">${totalDeleted}</span>
            </div>

            <div>Categoría A <span style="float:right;">${categoriesDeleted.A || 0}</span></div>
            <div>Categoría B <span style="float:right;">${categoriesDeleted.B || 0}</span></div>
            <div>Categoría C <span style="float:right;">${categoriesDeleted.C || 0}</span></div>
            <div>Categoría D <span style="float:right;">${categoriesDeleted.D || 0}</span></div>
          </div>
        `;
      }
    },

    plotOptions: {
      line: {
        marker: {
          enabled: true,
          radius: 4
        },
        dataLabels: {
          enabled: true,
          style: {
            textOutline: "none",
            fontSize: "11px",
            fontWeight: "600"
          },
          formatter: function () {
            return this.y;
          }
        }
      }
    },

    series: [
      {
        name: "Objetivos Eliminados",
        data: deletedByDay,
        color: "#2caffe"
      }
    ],

    credits: { enabled: false }
  };
};

export default indicatorTaskDeleted;
